// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__8R-Qz","loader":"loader_loader__vsYAF","spin":"loader_spin__Xw14Y"};